import { render, staticRenderFns } from "./PushNotificationTemplate.vue?vue&type=template&id=506047b6&scoped=true"
import script from "./PushNotificationTemplate.vue?vue&type=script&lang=js"
export * from "./PushNotificationTemplate.vue?vue&type=script&lang=js"
import style0 from "./PushNotificationTemplate.vue?vue&type=style&index=0&id=506047b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506047b6",
  null
  
)

export default component.exports